export const TOUR_VIEW_ANCHORS = {
  "graph-overview": [
    "graph-topbar",
    "graph-toolbar",
    "graph-issues",
    "graph-palette-scene",
    "graph-palette-interaction",
    "graph-scene-card",
    "graph-scene-card-latest",
    "graph-interior-enter",
  ],
  "scene-interior": [
    "interior-entry-node",
    "interior-breadcrumb",
    "interior-toolbar",
    "interior-link-filters",
    "interior-palette",
    "interior-timeline",
    "interior-dormant-zone",
  ],
  "graph-relink-modal": ["graph-relink-source", "graph-relink-confirm"],
  "stats-global": ["stats-global-kpis", "stats-global-charts"],
  "stats-parcours": ["stats-parcours-table"],
  "stats-parcours-detail": ["stats-parcours-modules"],
  "stats-module": [
    "stats-module-kpis",
    "stats-module-graph",
    "stats-module-tab-sessions",
    "stats-module-sessions",
  ],
  "stats-classement": ["stats-classement-controls"],
  "stats-comparateur": ["stats-comparateur-picker"],
  "stats-reports": ["stats-reports-new"],
  "stats-tabs": [
    "stats-tab-parcours",
    "stats-tab-classement",
    "stats-tab-comparateur",
    "stats-tab-reports",
  ],
  "demo-data-banner": ["demo-data-banner"],
  dashboard: ["dashboard-new-course", "course-card-open", "module-card-open"],
  "courses-list": ["course-card-open"],
  "course-modules": ["course-new-module"],
  "course-modules-cards": ["module-card-open", "module-card-latest"],
  "nav-tabs": [
    "tab-preview",
    "tab-learners",
    "tab-team",
    "tab-publish",
    "tab-organization",
    "module-wizard-start",
  ],
  "nav-back": ["nav-back"],
  "module-sidebar": ["project-create-scene", "project-soundtrack"],
  "app-sidebar": ["sidebar-installations", "sidebar-learners", "sidebar-team", "sidebar-profile"],
  "course-wizard-name": ["course-wizard-name"],
  "course-wizard-thumbnail": ["course-wizard-thumbnail"],
  "course-wizard-menu-media": ["course-wizard-menu-media"],
  "course-wizard-theme": ["course-wizard-theme"],
  "course-wizard-access": ["course-wizard-access"],
  "module-wizard-templates": ["module-wizard-start", "module-wizard-ai"],
  "module-wizard-stepper": ["module-wizard-overview"],
  "module-wizard-languages": ["module-wizard-languages"],
  "module-wizard-name": ["module-wizard-name"],
  "module-wizard-thumbnail": ["module-wizard-thumbnail"],
  publication: [
    "publish-new",
    "publish-builds-published",
    "publish-build-share",
    "publish-build-install",
  ],
  "publish-choice": ["publish-choice"],
  "publish-select-modules": ["publish-select-modules"],
  "publish-select-platforms": ["publish-select-platforms"],
  "publish-confirm": ["publish-confirm"],
  "course-team": ["course-team-add-existing", "course-team-list", "add-team-picker"],
  "add-team-picker": ["add-team-picker"],
  "org-team": ["team-invite", "team-list"],
  "org-settings": ["org-ai-context"],
  "course-learners": ["learners-add"],
  "user-form": ["user-form-submit"],
  "scenaria-workbench": [
    "scenaria-workbench-agents",
    "scenaria-workbench-attachments",
    "scenaria-workbench-composer",
    "scenaria-workbench-skip-intake",
    "scenaria-workbench-plan-card",
    "scenaria-workbench-generate",
  ],
  "scenaria-rail": ["scenaria-field-focus", "scenaria-proposal", "scenaria-composer"],
  "media-gallery": ["media-gallery-confirm"],
  "enduser-stats-tabs": ["stats-tab-parcours", "stats-tab-comparateur"],
  "enduser-stats-overview": ["stats-overview"],
  "route-loading": [],
  "module-page": [],
  "graph-page": [],
} as const;

export type TourViewId = keyof typeof TOUR_VIEW_ANCHORS;

export type TourViewAnchor<V extends TourViewId> = typeof TOUR_VIEW_ANCHORS[V][number];

export const hostedTourAnchors = <V extends TourViewId>(
  viewId: V,
  candidates: readonly string[],
): TourViewAnchor<V>[] =>
  candidates.filter((anchor): anchor is TourViewAnchor<V> =>
    (TOUR_VIEW_ANCHORS[viewId] as readonly string[]).includes(anchor),
  );

export const isAnchorOf =
  <V extends TourViewId>(_viewId: V, ...names: TourViewAnchor<V>[]) =>
  (anchor: TourViewAnchor<V>): boolean =>
    names.includes(anchor);
